define(
    'views/forum_description.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/forum_description.html'
    ],
    function(Loader, Config, Helper, Sandbox, forumDescriptionTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var ForumDescriptionView = Loader.Backbone.View.extend(
            {

                events: Helper.prepareEventsForDevice(
                    {
                        'click #saveForumDescription': 'saveDesc',
                        'keydown  #board_description': 'descLength',
                        'keypress #board_description': 'descLength',
                        'keyup    #board_description': 'descLength'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/admin_index.php$": "description"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');
                    var user =  this.model.get('users').getMe();

                    this.model.on('startApplication', function(){
                        if (user.get('groupId') == 1 && Config.modules.boardDescription.enabled)
                            Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    if (Config.modules.boardDescription.enabled == false) return this;

                    var elem = $(".forumDescriptionBlock");

                    var compiledTemplate = _.template(
                        forumDescriptionTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    elem.html(compiledTemplate);
                    this.descLength();
                    return this;
                },

                description: function()
                {
                    var _this = this;

                    var elem = $("#pun-admain1:first");
                    elem.after('<div id="pun-admain1" class="adformal forumDescriptionBlock"></div>');
                    this.render();

                    this.model.get('forum').getDescription(function(data){
                        _this.render();
                    });
                },

                descLength: function(){

                    if ($('#board_description').length == 0) return;

                    var textLength = $('#board_description').val().length,
                        $descLength = $('#descLength');

                    if (textLength < 1000) {
                        $descLength.css('color', 'red');
                    }
                    else if (textLength < 2000) {
                        $descLength.css('color', 'orange');
                    }
                    else {
                        $descLength.css('color', 'green');
                    }

                    $descLength.html(textLength);
                },

                saveDesc: function(e)
                {
                    var button = $(e.target);
                    button.attr('disabled', true);
                    button.val('Сохраняю...');

                    var text = $('#board_description').val();

                    this.model.get('forum').saveDescription(text, function(){
                        location.reload(true);
                    }, function(){
                        button.attr('disabled', false);
                        button.val('Сохранить');
                        alert('Произошла ошибка при сохранении описания');
                    });
                }
            });

        return {
            initialize: function(model)
            {
                return new ForumDescriptionView({
                    el: $("#pun-admain"),
                    model: model
                })
            }
        }
    }
);
